import React, { memo } from "react";
import Image, { StaticImageData } from "next/image";
import { Typography } from "@/components/ui/typography";
import { cn } from "@/lib/utils";
import Link, { LinkProps } from "next/link";

export type DocumentCardLinkProps = {
  title: string;
  imageUrl: string | StaticImageData;
} & React.ComponentProps<"a"> &
  LinkProps;

const DocumentCardLink = ({
  title,
  imageUrl,
  href = "#",
  className,
}: DocumentCardLinkProps) => {
  return (
    <Link
      href={href}
      className={cn(
        "flex bg-white border border-neutral-200 rounded-2xl overflow-hidden lg:border-[2px] lg:bg-cloud-gray lg:border-transparent transition-[box-shadow,border-color,background-color] hover:border-blue hover:bg-white hover:shadow-[0px_4px_4px_0_rgba(0,0,0,0.25)]",
        className
      )}
    >
      <div className="grid grid-cols-1 gap-4 place-content-start flex-auto min-w-0 py-6 px-4 lg:py-4 lg:px-6.5 lg:gap-2.5">
        <div className="mx-auto inline-flex items-center justify-center rounded-2xl overflow-hidden bg-white w-12 h-12 lg:w-[120] lg:h-[120]">
          <Image
            alt={title}
            src={imageUrl}
            width={0}
            height={0}
            className="min-w-[100] min-h-100 lg:w-full lg:h-full"
          />
        </div>
        <Typography
          variant="titleMd"
          className="text-semantic-text-primary font-semibold lg:leading-[150%] lg:font-medium text-center"
          asChild
        >
          <h4>{title}</h4>
        </Typography>
      </div>
    </Link>
  );
};

export default memo(DocumentCardLink);
